export default __webpack_public_path__ + "static/SRUS 1360PW - Product Specifications & Technical Data-bed1ae8e26dc00d02becba57c090f37a.pdf";